import { Navigate, useParams } from 'react-router-dom';
import { ContentLoader } from '@/components/common';
import { useAuthStore } from '@/store/auth';
import { usePospChannel } from '@/hooks/useBrokers';
import { legacyPospRedirect } from '@/routing/legacyPospRedirect';

export function LegacyPospRedirect() {
  const { id } = useParams<{ id: string }>();
  const role = useAuthStore((s) => s.user?.role);
  const decision = legacyPospRedirect(role, id);
  if ('to' in decision) return <Navigate to={decision.to} replace />;
  return <ResolveChannelRedirect pospId={decision.pospId} />;
}

function ResolveChannelRedirect({ pospId }: { pospId: string }) {
  const { data, isLoading } = usePospChannel(pospId);
  if (isLoading) return <ContentLoader />;
  return (
    <Navigate
      to={data?.channel_id ? `/broker/channels/${data.channel_id}` : '/broker/channels?type=POSP'}
      replace
    />
  );
}
